import { Controller } from 'stimulus'

const IDENTITY_TYPES = ['identity_front', 'identity_back']

export default class extends Controller {
    static targets = ['validUntilWrapper']

    connect() {
        this.toggle()
    }

    toggle() {
        const select  = this.element.querySelector('select[name*="document_type"]')
        const visible = IDENTITY_TYPES.includes(select?.value)

        this.validUntilWrapperTarget.classList.toggle('d-none', !visible)
    }
}
